(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('DbhawkUserService', DbhawkUserService);

    DbhawkUserService.$inject = ['$http'];

    function DbhawkUserService($http) {

        this.getUsersForInstance = function getUsersForInstance(instance){
            return $http.get(SERVER_API_URL+'api/dbhawk/users/'+instance)
        }

        this.getRedirectToAppUrl = function getRedirectToAppUrl(){
            return $http.post(SERVER_API_URL+'api/dbhawk/users/instance/url')
        }

        this.getCompanyDetails = function getRedirectToAppUrl(){
            return $http.get(SERVER_API_URL+'api/companies/user')
        }

    }
})();
